module.exports = __webpack_public_path__ + "static/html/gm_page.html";


//////////////////
// WEBPACK FOOTER
// ./static/html/gm_page.html
// module id = 2215
// module chunks = 0